import * as React from 'react';
import { ContentView } from '@levelapp/softfabric';
import CheckBoxListViewStyle from './CheckBoxListViewStyle';
import CheckBoxListViewModel from './CheckBoxListViewModel';
import { View, TouchableWithoutFeedback, Text } from 'react-native';
export default class CheckBoxListView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new CheckBoxListViewModel(this), new CheckBoxListViewStyle(this));
    }
    /* RENDERING */
    render() {
        return (React.createElement(View, { style: this.props.style != undefined ? this.props.style : this.style.shell }, this.props.data && this.props.data.length > 0 ? this.props.data.map((value, index) => {
            return (React.createElement(TouchableWithoutFeedback, { key: index, onPress: () => this.binding.onCheck(index) },
                React.createElement(View, { style: this.style.containerItem },
                    React.createElement(View, { style: this.binding.IdInState(index) ?
                            (this.props.containerChecked != undefined ? this.props.containerChecked
                                : [this.style.containerChecked, this.props.color ? { borderColor: this.props.color } : null]) : this.props.container != undefined ? this.props.container : this.style.container },
                        React.createElement(View, { style: this.binding.IdInState(index) ?
                                (this.props.contentChecked != undefined ? this.props.contentChecked
                                    : [this.style.contentChecked, this.props.color ? { backgroundColor: this.props.color } : null]) : this.props.content != undefined ? this.props.content : this.style.content })),
                    React.createElement(View, { style: this.style.item }, this.props.isText ? React.createElement(Text, { style: this.props.textStyle }, value) : value))));
        }) : null));
    }
}
